const COLORS = [
  'red',
  'green',
  'blue',
  // 'yellow',
  'purple',
  'orange',
  // 'brown',
  // 'gray',
]

export { COLORS }
